import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import type { Sites } from '~/types/global.types'

export default defineNuxtPlugin(() => {
    const isProd = import.meta.env.PROD
    const { calltouchEnabled, website } = useRuntimeConfig().public
    if (!isProd || !calltouchEnabled) return

    // Мапа ключ → URL-скрипта (подставь реальные ссылки Calltouch)
    // Все ключи одинаковые — это согласовано, так и должно быть
    const CALLTOUCH_KEYS: Record<Sites, string> = {
        'cromi.ru': 'x29mwah9',
        'cromi.rent': 'x29mwah9',
        'radioguide.rent': 'x29mwah9',
    }

    const key = website ? CALLTOUCH_KEYS[website] : undefined

    useHead({
        script: [
            {
                type: 'text/javascript',
                innerHTML: `(function(w,d,n,c){w.CalltouchDataObject=n;w[n]=function(){w[n]["callbacks"].push(arguments)};if(!w[n]["callbacks"]){w[n]["callbacks"]=[]}w[n]["loaded"]=false;if(typeof c!=="object"){c=[c]}w[n]["counters"]=c;for(var i=0;i<c.length;i+=1){p(c[i])}function p(cId){var a=d.getElementsByTagName("script")[0],s=d.createElement("script"),i=function(){a.parentNode.insertBefore(s,a)},m=typeof Array.prototype.find === 'function',n=m?"init-min.js":"init.js";s.async=true;s.src="https://mod.calltouch.ru/"+n+"?id="+cId;if(w.opera=="[object Opera]"){d.addEventListener("DOMContentLoaded",i,false)}else{i()}}})(window,document,"ct","${key}");`,
            },
        ],
    })
})
